/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getUsage() {
    return axios.get(`${this.url}/usage`);
  }

  getInvoices(page = 1, perPage = 20) {
    return axios.get(`${this.url}/invoices?page=${page}&per_page=${perPage}`);
  }

  getPlans() {
    return axios.get(`${this.url}/plans`);
  }

  changePlan(planId, billingCycle = 'monthly') {
    return axios.post(`${this.url}/change_plan`, {
      plan_id: planId,
      billing_cycle: billingCycle,
    });
  }

  cancelSubscription(immediate = false, reason = '') {
    return axios.post(`${this.url}/cancel`, { immediate, reason });
  }

  reactivate() {
    return axios.post(`${this.url}/reactivate`);
  }

  managePayment() {
    return axios.post(`${this.url}/manage_payment`);
  }

  manageBillingInfo() {
    return axios.post(`${this.url}/manage_billing_info`);
  }

  getMacHistory(periodStart, periodEnd, inboxId) {
    let url = `${this.url}/mac_history?`;
    if (periodStart) url += `period_start=${periodStart}&`;
    if (periodEnd) url += `period_end=${periodEnd}&`;
    if (inboxId) url += `inbox_id=${inboxId}`;
    return axios.get(url);
  }

  getLlmUsageHistory({ periodStart, periodEnd, feature, model, agentId } = {}) {
    let url = `${this.url}/llm_usage_history?`;
    if (periodStart) url += `period_start=${periodStart}&`;
    if (periodEnd) url += `period_end=${periodEnd}&`;
    if (feature) url += `feature=${feature}&`;
    if (model) url += `model=${model}&`;
    if (agentId) url += `agent_id=${agentId}`;
    return axios.get(url);
  }

  syncInvoices() {
    return axios.post(`${this.url}/sync_invoices`);
  }

  purchaseAddOn(productId, quantity) {
    return axios.post(`${this.url}/purchase_add_on`, {
      product_id: productId,
      quantity,
    });
  }

  getAddOns() {
    return axios.get(`${this.url}/add_ons`);
  }

  getAddOnProducts() {
    return axios.get(`${this.url}/add_on_products`);
  }

  cancelAddOn(addOnId) {
    return axios.post(`${this.url}/cancel_add_on`, { add_on_id: addOnId });
  }
}

export default new BillingAPI();
